import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Button } from "@mui/material";

//import { DatePicker } from "@mui/x-date-pickers";

const TruckDetails = ({ truck, onUpdate }) => {
  const [editMode, setEditMode] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const [editedValues, setEditedValues] = useState({ ...truck });

  const handleInputChange = (event, key) => {
    const { value } = event.target;
    setEditedValues((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleEdit = () => {
    setExpanded(true);
    setEditMode(true);
  };

  const handleSave = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}truck/${truck.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
          },
          body: JSON.stringify(editedValues),
        }
      );

      if (response.ok) {
        // Handle successful update
        onUpdate(editedValues);
        //setExpanded(true);
        setEditMode(false);
      } else {
        // Handle error case
        console.error("Error updating truck details");
        // Perform additional error handling if needed
      }
    } catch (error) {
      console.error("Error updating truck details:", error);
      // Handle error case
    }
  };

  const labelStyle = {
    fontWeight: "bold",
    marginRight: "8px",
  };

  const inputStyle = {
    marginBottom: "16px",
  };

  const buttonStyle = {
    marginTop: "16px",
  };

  const formStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    border: "2px solid #ccc",
    borderRadius: "4px",
    padding: "16px 24px", // Increase left and right padding
    marginBottom: "24px", // Increase distance between boxes
    cursor: "pointer",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
    margin: "8px",
  };

  const handleBoxClick = (event) => {
    // Prevent toggling collapse when clicking on input fields, edit button, or save button
    const tagName = event.target.tagName.toLowerCase();
    if (tagName === "input" || tagName === "textarea" || tagName === "button") {
      return;
    }

    setExpanded(!expanded);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <div style={formStyle} onClick={handleBoxClick}>
      {expanded ? (
        editMode ? (
          <>
            <TextField
              label="Vehicle Number"
              value={editedValues.gaadi_no || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "gaadi_no")}
            />
            <br />
            <TextField
              label="Size"
              value={editedValues.size || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "size")}
            />
            <br />
            <TextField
              label="Owner"
              value={editedValues.owner || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "owner")}
            />
            <br />
            <TextField
              label="Owner Phone Number"
              value={editedValues.owner_phone_no || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "owner_phone_no")}
            />
            <br />
            <TextField
              label="Company Name"
              value={editedValues.company_name || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "company_name")}
            />
            <br />
            <TextField
              label="Chasis Number"
              value={editedValues.chasis_number || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "chasis_number")}
            />
            <br />
            <TextField
              label="Engine Number"
              value={editedValues.engine_number || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "engine_number")}
            />
            <br />
            <TextField
              label="PUC"
              value={editedValues.PUC || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "PUC")}
            />
            <br />
            <TextField
              label="RC Number"
              value={editedValues.RC_number || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "RC_number")}
            />
            <br />
            <TextField
              label="RC Registration Date"
              value={editedValues.RC_reg_date || ""}
              type="date"
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "RC_reg_date")}
            />
            <br />
            <TextField
              label="RC Expiration Date"
              value={editedValues.RC_exp_date || ""}
              type="date"
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "RC_exp_date")}
            />
            <br />
            <TextField
              label="Policy Number"
              value={editedValues.policy_no || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "policy_no")}
            />
            <br />
            <TextField
              label="Fitness Number"
              value={editedValues.fitness_no || ""}
              style={inputStyle}
              onChange={(event) => handleInputChange(event, "fitness_no")}
            />
            <br />

            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              style={buttonStyle}
            >
              Save
            </Button>
          </>
        ) : (
          <>
            <p>
              <span style={labelStyle}>Vehicle Number:</span>
              {truck.gaadi_no}
            </p>
            <p>
              <span style={labelStyle}>Size:</span>
              {truck.size}
            </p>
            <p>
              <span style={labelStyle}>Owner:</span>
              {truck.owner}
            </p>
            <p>
              <span style={labelStyle}>Owner Phone Number:</span>
              {truck.owner_phone_no}
            </p>
            <p>
              <span style={labelStyle}>Company Name:</span>
              {truck.company_name}
            </p>
            <p>
              <span style={labelStyle}>Chasis Number:</span>
              {truck.chasis_number}
            </p>
            <p>
              <span style={labelStyle}>Engine Number:</span>
              {truck.engine_number}
            </p>
            <p>
              <span style={labelStyle}>PUC:</span>
              {truck.PUC}
            </p>
            <p>
              <span style={labelStyle}>RC Number:</span>
              {truck.RC_number}
            </p>
            <p>
              <span style={labelStyle}>RC Registration Date:</span>
              {formatDate(truck.RC_reg_date)}
            </p>
            <p>
              <span style={labelStyle}>RC Expiration Date:</span>
              {formatDate(truck.RC_exp_date)}
            </p>
            <p>
              <span style={labelStyle}>Policy Number:</span>
              {truck.policy_no}
            </p>
            <p>
              <span style={labelStyle}>Fitness Number:</span>
              {truck.fitness_no}
            </p>

            <Button
              variant="contained"
              color="primary"
              onClick={handleEdit}
              style={buttonStyle}
            >
              Edit
            </Button>
          </>
        )
      ) : (
        <>
          <p>
            <span style={labelStyle}>Vehicle Number:</span>
            {truck.gaadi_no}
          </p>
          <p>
            <span style={labelStyle}>RC Expiration Date:</span>
            {formatDate(truck.RC_exp_date)}
          </p>
          <p>
            <span style={labelStyle}>Company Name:</span>
            {truck.company_name}
          </p>
        </>
      )}
    </div>
  );
};

const EditTruck = () => {
  const trucks = useSelector((state) => state.dataReducer.trucks);
  const [truckdetail, setTruckdetail] = useState({ car: [] });

  useEffect(() => {
    console.log("useEffect is called");
    setTruckdetail(trucks);
  }, [trucks]);

  const handleTruckUpdate = (updatedValues) => {
    // Update the truck details in the local state
    setTruckdetail((prevState) => {
      const updatedTrucks = prevState.car.map((truck) => {
        if (truck.id === updatedValues.id) {
          return { ...truck, ...updatedValues };
        }
        return truck;
      });
      return { ...prevState, car: updatedTrucks };
    });
  };

  const sortedTrucks = Array.isArray(truckdetail.car)
    ? [...truckdetail.car].sort((a, b) => {
        const dateA = new Date(a.RC_exp_date);
        const dateB = new Date(b.RC_exp_date);
        return dateA - dateB;
      })
    : [];

  return (
    <>
      {sortedTrucks.map((truck, index) => (
        <TruckDetails key={index} truck={truck} onUpdate={handleTruckUpdate} />
      ))}
    </>
  );
};

export default EditTruck;
